/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationRelationshipRequestDto
 */
export interface CreateOrganizationRelationshipRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipRequestDto
     */
    relationType: CreateOrganizationRelationshipRequestDtoRelationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipRequestDto
     */
    orgId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipRequestDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRelationshipRequestDto
     */
    notes?: string;
}


/**
 * @export
 */
export const CreateOrganizationRelationshipRequestDtoRelationTypeEnum = {
    Client: 'CLIENT',
    Landlord: 'LANDLORD',
    Oem: 'OEM'
} as const;
export type CreateOrganizationRelationshipRequestDtoRelationTypeEnum = typeof CreateOrganizationRelationshipRequestDtoRelationTypeEnum[keyof typeof CreateOrganizationRelationshipRequestDtoRelationTypeEnum];


/**
 * Check if a given object implements the CreateOrganizationRelationshipRequestDto interface.
 */
export function instanceOfCreateOrganizationRelationshipRequestDto(value: object): value is CreateOrganizationRelationshipRequestDto {
    if (!('relationType' in value) || value['relationType'] === undefined) return false;
    if (!('orgId' in value) || value['orgId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    return true;
}

export function CreateOrganizationRelationshipRequestDtoFromJSON(json: any): CreateOrganizationRelationshipRequestDto {
    return CreateOrganizationRelationshipRequestDtoFromJSONTyped(json, false);
}

export function CreateOrganizationRelationshipRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRelationshipRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationType': json['relationType'],
        'orgId': json['orgId'],
        'partnerOrgId': json['partnerOrgId'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateOrganizationRelationshipRequestDtoToJSON(json: any): CreateOrganizationRelationshipRequestDto {
    return CreateOrganizationRelationshipRequestDtoToJSONTyped(json, false);
}

export function CreateOrganizationRelationshipRequestDtoToJSONTyped(value?: CreateOrganizationRelationshipRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationType': value['relationType'],
        'orgId': value['orgId'],
        'partnerOrgId': value['partnerOrgId'],
        'notes': value['notes'],
    };
}

